<template>
    <div>
        <table>
            <tr>
                <td>
                    File
                </td>
                <td>
                    <treeselect class="smalltreeselect" :load-options="loadOptions" v-model="settings.uplcfile" :options="options" />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </table>
    </div>
</template>

<script>
import actionMixin from './action.mixin';

export default {
    mixins: [actionMixin],
    methods: {
        loadOptions(arg){
            this.$api.compatibilityEmit('getUPLCFiles', (files)=>{
                this.options = files.map(f=>({
                    id: f,
                    label: f,
                }));
                arg.callback();
            })
        },
    },
    props: [
        'solvents',
        'lastsolvent',
        'uplcfiles'
    ],
    data: function(){return{
        needles: [
            'ND1',
            'ND2'
        ],
        options: null
    }},
    beforeMount: function(){
        Vue.set(this.settings, 'inputTypes', ['SnapvialSample']);
        //Vue.set(this.settings, 'outputType', 'SnapvialSample');

        
        this.setDefault('uplcfile', null); 
        
    }
}

</script>

<style>
    
</style>

<style lang="scss" src="./action.scss" scoped>